import { ApplicationTypes, PD7Hole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const pd7HoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('PD7Hole')
    .attach(() => {
      return {
        title: featureLabels[PD7Hole.type],
        subtitle: '',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/pd7.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('PD7Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('PD7Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  attachComponent
    .withEntity('PD7Hole')
    .withComponent(dimensionIndicatorComponent, 'primaryCircleRadius')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Finalization],
    })
    // TODO: memoEval
    .attach(s => {
      return {
        ...bendHoleDimensionIndicatorCoordinates(s, {
          startX: 0,
          endX: 0,
          startY: -s.primaryRadius,
          endY: s.primaryRadius,
          startZ: s.$plate.thickness + 0.1,
          endZ: s.$plate.thickness + 0.1,
          extrusionX: 0,
        }),
        arrowHeadType: ArrowHeadType.CONE,
        arrowHeadSize: 4,
        labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
        label: `R=${s.primaryRadius}`,
      }
    }),
]
